import React, { useState, useEffect } from 'react';
import { useTranslation } from 'react-i18next';
import AnimatedLogo from './AnimatedLogo';
import './Navigation.css';

const Navigation = () => {
  const { t, i18n } = useTranslation();
  const [isMenuOpen, setIsMenuOpen] = useState(false);
  const [isScrolled, setIsScrolled] = useState(false);

  const changeLanguage = (lng) => {
    i18n.changeLanguage(lng);
  };

  const toggleMenu = () => {
    setIsMenuOpen(!isMenuOpen);
  };

  const closeMenu = () => {
    setIsMenuOpen(false);
  };

  // 监听滚动事件
  useEffect(() => {
    const handleScroll = () => {
      const scrollTop = window.pageYOffset || document.documentElement.scrollTop;
      setIsScrolled(scrollTop > 50);
    };

    window.addEventListener('scroll', handleScroll);
    return () => window.removeEventListener('scroll', handleScroll);
  }, []);

  return (
    <nav className={`navigation ${isScrolled ? 'scrolled' : ''}`}>
      <div className="container">
        <div className="nav-content">
          <div className="nav-logo">
            <AnimatedLogo size="small" className="logo-icon" />
            <span className="logo-text">
              <span className="company-name">Crypto Ocean</span>
              <span className="company-suffix"> Pty Ltd</span>
            </span>
          </div>
          
          <div className={`nav-menu ${isMenuOpen ? 'nav-menu-open' : ''}`}>
            <a href="#hero" className="nav-link" onClick={closeMenu}>首页</a>
            <a href="#products" className="nav-link" onClick={closeMenu}>产品</a>
            <a href="#about" className="nav-link" onClick={closeMenu}>关于我们</a>
            <a href="#contact" className="nav-link" onClick={closeMenu}>联系我们</a>
          </div>
          
          <div className="nav-actions">
            <div className="language-switcher">
              <button
                className={`lang-btn ${i18n.language === 'zh' ? 'active' : ''}`}
                onClick={() => changeLanguage('zh')}
              >
                中文
              </button>
              <button
                className={`lang-btn ${i18n.language === 'en' ? 'active' : ''}`}
                onClick={() => changeLanguage('en')}
              >
                EN
              </button>
            </div>
            
            <button 
              className={`hamburger-menu ${isMenuOpen ? 'hamburger-open' : ''}`}
              onClick={toggleMenu}
              aria-label="Toggle menu"
            >
              <span className="hamburger-line"></span>
              <span className="hamburger-line"></span>
              <span className="hamburger-line"></span>
            </button>
          </div>
        </div>
      </div>
      
      {/* 移动端遮罩层 */}
      {isMenuOpen && (
        <div className="mobile-overlay" onClick={closeMenu}></div>
      )}
    </nav>
  );
};

export default Navigation; 